<script>
  import { Bus } from '@/lib/consts'
  import StateMixin from '@/components/report/mixins/StateMixin'
  import RingVect from '@/components/svg/RingVect'

  export default {
    mixins: [ StateMixin ],
    props: {
      winHForced: [ Number, Boolean ],
      idx: { type: Number, required: true },
      keyword: { type: String, required: true },
      heading: { type: String, required: true },
      subhead: { type: String, required: true },
      numeral: { type: String, required: true },
      forceTween: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        active: false,
        time: 1.5,
        stagger: 0.1,
        headSpace: 0.5, // -> 0.1
        kwSpace: 0.65,  // -> 0.2666
        headSpans: null,
        kwSpans: null,
        winHFix: window.innerHeight,
        winWFix: window.innerWidth
      }
    },
    computed: {
      head () {
        return this.heading.replace( /[a-z\s](?!r>|>)/gi, '<span>$&</span>' )
      },
      kw () {
        return '<span>' + this.keyword.split( '' ).join( '</span><span>' ) + '</span>'
      },
      wrapH () {
        return this.winHForced || this.winHFix || this.winH
      },
      wrapStyles () {
        return this.winHForced ? { height: this.winHForced + 'px' } : {}
      },
      txtStyles () {
        return this.winHForced ? { height: this.wrapH + 'px' } : {}
      },
      deskBigCircCx () {
        return this.winWFix / 2
      },
      deskBigCircCy () {
        return (this.wrapH / 2) - (this.wrapH * 0.1)
      }
    },
    methods: {
      hasRefs () {
        return Object.values( this.$refs ).filter( el => typeof el === 'undefined' ).length === 0
      }
    },
    mounted () {
      this.headSpans = this.$refs.head.querySelectorAll( 'span' )
      this.kwSpans = this.$refs.kw.querySelectorAll( 'span' )
      this.winHFix = this.$el.clientHeight // So title SVG's behave a bit better on iOS
      this.winWFix = this.$el.clientWidth
      this.$on( 'tween-done', () => {
        this.active = true
      } )
      this.setTweens()

      if ( this.forceTween ) {
        this.$nextTick( () => {
          setTimeout( () => {
            document.body.classList.add( 'show-gnav' )
            document.body.classList.remove( 'hide-gnav' )
            if ( !this.isMobile ) window.scrollTo( 0, 0 )
          }, 500 )
          this.tweenIn()
        } )
      }

      Bus.$on( 'tweenTitles', () => {
        setTimeout( () => {
          document.body.classList.add( 'show-gnav' )
          document.body.classList.remove( 'hide-gnav' )
        } )
        if ( this.hasRefs() ) this.tweenIn()
      } )

      Bus.$on( 'resized', () => {
        let hEmitted = this.idx === 0 ? window.innerHeight : this.$el.clientHeight
        this.winHFix = this.$el.clientHeight
        this.winWFix = this.$el.clientWidth
        Bus.$emit( 'titleVectHeight', hEmitted )
      } )
      Bus.$emit( 'titleVectHeight', this.winHFix )
    },
    components: {
      RingVect
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .page-title-wrap {

    .heading span, .keyword span, .subhead, .ring-vector, .numeral {
      // intro animation start state
      opacity : 0;
    }

    > svg {
      width : 100vw;
    }

    &:not(.page-0):not(.page-7) {
      > svg {
        height : 100vh;
      }
    }

    .heading {
      font-family    : $knockout-30;
      font-size      : rem(56);
      line-height    : rem(62);
      letter-spacing : rem(6);
      font-weight    : normal;
      text-transform : uppercase;
      margin         : 0 0 viewport-scale(15);
      white-space    : nowrap;

      @include screen-md-lg-xl {
        font-size   : rem(72);
        line-height : rem(80);
      }

      .style-extended & {
        font-size      : rem(62);
        line-height    : rem(68);
        letter-spacing : rem(6.64);
      }

      span {
        opacity : 0;
      }
    }

    .subhead {
      font-size   : rem(15);
      line-height : rem(24);
      color       : $white;
      text-align  : center;
      font-family : $adobe-clean-serif;
      font-weight : 400;
      font-style  : italic;
      opacity     : 0;
      width       : 75%;

      @include screen-md-lg-xl {
        max-width  : 340px;
        margin-top : rem(8);
        font-size  : rem(18);
      }

      .style-extended & {
        font-size   : rem(20);
        line-height : rem(30);
        width       : 95%;
      }
    }

    .keyword {
      font-size      : rem(12);
      letter-spacing : rem(3.2);
      line-height    : rem(15);
      margin-bottom  : rem(15);
      font-weight    : 800;
      text-transform : uppercase;

      .style-extended & {
        font-size : rem(14);
      }

      span {
        opacity : 0;
      }
    }

    .header-wrap {
      flex : 1 0 50%;

      @include screen-md-lg-xl {
        flex     : 1 0 auto;
        position : absolute;
        bottom   : 44vh;
        width    : 100%;

        @media screen and (min-height : 900px) {
          bottom : 48vh;
        }
      }
    }

    .footer-wrap {
      flex : 1 1 viewport-scale(170);

      @include screen-md-lg-xl {
        flex     : 1 1 auto;
        position : absolute;
        bottom   : 0;
        width    : 100%;
        height   : 258px;
      }
    }

    .title-text {
      left      : 50%;
      transform : translateX(-50%);
      top       : 0;
      height    : 100vh;
      color     : #fff;
    }

    .numeral {
      font-size      : rem(30);
      letter-spacing : 0.05em;
    }

    .orb-vect {
      width  : 60px;
      height : 45px;
    }

    .ring-vector {
      width  : 85px;
      height : 86px;
    }

    .ring-vector .ring-vect-circle {
      stroke-width : 4px;
    }

    .numeral {
      line-height : 0;
      margin-top  : -0.085em;

      &::after {
        content  : '.';
        position : absolute;
        left     : 100%;
      }
    }

    .dashes {
      height              : 85px;
      width               : 3px;
      margin-top          : rem(15);
      transform           : translateY(-100%);
      left                : calc(50% - 2px);
      backface-visibility : hidden;

      &, .inner {
        transition : transform $data-trans-time ease-in-out;
      }

      .inner {
        transform : translateY(100%);
        width     : 1px;
        left      : 50%;
      }
    }

    &.active .dashes {
      &, .inner {
        transform : translateY(0);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/mixins/TitleMixin.vue